import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';

import axios, { Axios } from 'axios';
import parse from "html-react-parser";
import { Link, useNavigate } from "react-router-dom";
import { variables } from './Variables.js';
import { FALSE } from 'sass';
import TrendingList_Ar from './TrendingList_Ar.js';

// If You Want To Import Specific Css File use this way
// import "./arabic.css";

//New Coins Arabic

import TrendingNewsCoins_Ar from './TrendingNewsCoins_Ar.js';
import Most_View_Ar from './Most_View_Ar.js';
import NewFeature_Ar from './NewFeature_Ar.js';
import ListMainArticle_Ar from './ListMainArticle_Ar.js';
import TrendyPage_AR from './TrendyPage_AR.js';
import Latest_Ar from './Latest_Ar.js';
import Popular_Ar from './Popular_Ar.js';
import SportList_Ar from './SportList_Ar.js';
import WhatsnewHome_Ar from './WhatsnewHome_Ar.js';



export default function Arabic() {


  const [isLoading, setNisLoading] = useState(false);
  const navigate = useNavigate();
  const usenavigate = useNavigate();


  async function refda() {
    setNisLoading(true);
    //  To Show or Hidden Header And Footer
    document.getElementById('Arabic_Header').hidden = false;
    document.getElementById('Arabic_Footer').hidden = false;
    //


  };

  useEffect(() => {


    setNisLoading(true);

    refda();
  }, [])









  return (
    <>


      <section className="all-post-style-2-area mt-3">
        <div className="container custom-container">
          <div className="row">
            <div className="col-lg-8 mb-auto newabed">
              {/* New TrendingNewsCoins */}
              <TrendingNewsCoins_Ar />
            </div>


            <div className="col-lg-4 mb-auto">
              <div className="trending-right-sidebar">
                {/* Social Media Last */}
                <div className="trending-most-view mt-1 ">
                  <div className="section-title">
                    <h3 className="title float-right">الأكثر مشاهدة</h3>
                    <br></br>
                  </div>
                </div>
                {/* MostView */}
                <Most_View_Ar />
              </div>
              <img className='mt-3' src='./images/ad/ad-2.jpg' />
              

            </div>
          </div>
        </div>
      </section>

      {/* End First Section  */}



    
      <section className="feature-area   " >

        <NewFeature_Ar />
  

      </section>
     

     
        <ListMainArticle_Ar />

      
   
      
      

      {/* Start Section 2 */}
      {/* Main Article And List Conatin Main Article And ListArticle And Small Article */}
      
      {/* End Part of List Article */}




      {/* Part 3 Whats new And Sport .. */}


      <section className="post-style-area">
        <div className="container custom-container">
          <div className="row">
            <div className="col-lg-3 col-md-6">
              <div className="post-style-tab-post mt-40">
                <div className="tab-btn">
                  <ul className="nav nav-pills toEnglish" id="pills-tab" role="tablist">
                    <li className="nav-item " role="presentation">
                      <a className="nav-link active bg-warning text-white" id="pills-home-tab" data-toggle="pill" href="#pills-home" role="tab" aria-controls="pills-home" aria-selected="true">الموسم</a>
                    </li>
                    <li className="nav-item" role="presentation">
                      <a className="nav-link bg-warning text-white" id="pills-profile-tab" data-toggle="pill" href="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="false">اخر الاخبار</a>
                    </li>
                    <li className="nav-item" role="presentation">
                      <a className="nav-link bg-warning text-white" id="pills-contact-tab" data-toggle="pill" href="#pills-contact" role="tab" aria-controls="pills-contact" aria-selected="false">الشائع</a>
                    </li>
                  </ul>
                </div>
                <div className="tab-content" id="pills-tabContent">
                  <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                    <div className="post-style-items">


                      <TrendyPage_AR />




                    </div>

                  </div>
                  {/* end trendy */}
                  <div className="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                    <div className="post-style-items">



                      <Latest_Ar />

                    </div>

                  </div>
                  <div className="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
                    <div className="post-style-items">
                      <Popular_Ar />
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5 col-md-6">
              {/* المال والاعمال  */}
              <SportList_Ar />
            </div>
            <div className="mb-auto col-lg-4 ">
              {/* Whats New Here  */}
              <WhatsnewHome_Ar />

            </div>

          </div>
        </div>
      </section>

    </>
  );
}



